export default "__VITE_ASSET__HP6F3SBn__"